// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { env } from "./utils/environment";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: env.REACT_APP_API_FIREBASE_API_KEY,
  authDomain: env.REACT_APP_API_FIREBASE_AUTH_DOMAIN,
  projectId: env.REACT_APP_API_FIREBASE_PROJECT_ID,
  // storageBucket: env.REACT_APP_API_FIREBASE_STORAGE_BUCKET,
  // messagingSenderId: env.REACT_APP_API_FIREBASE_MESSAGE_SENDER_ID,
  appId: env.REACT_APP_API_FIREBASE_APP_ID,
  measurementId: env.REACT_APP_API_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const functions = getFunctions(app, "asia-northeast1");
const db = getFirestore(app);

if (env.REACT_APP_EMULATOR_MODE) {
  console.info("[firebase] connecting to emulators");
  connectAuthEmulator(auth, "http://127.0.0.1:9099");
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
} else {
  console.info("[firebase] using production services");
}

export { db, auth, functions };